<template>
  <div class="admin-area">
    <header class="flex items-center">
      <router-link :to="{name: 'home'}">Home</router-link>
      <h1 class="flex-grow w-full mx-base capitalize">{{title}}</h1>
    </header>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AdminArea',
  components: {
  },

  props: {
  },

  data: () => ({
  }),

  computed: {
    title () {
      return this.$route.name
    }
  },

  methods: {
  }
}
</script>

<style lang="scss">
.admin-area {
  position: relative;
  padding-top: var(--base-size);
  header {
    padding-left: var(--base-padding);
    padding-right: var(--base-padding);
  }
}
</style>
